import type { CareSearchPatientsRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

/**
 * Query keys for Care patient list retrieval.
 */
export const carePatientsKeys = {
  all: ['care', 'patients'] as const,

  search: (request: CareSearchPatientsRequestT) => ['care', 'patients', 'search', request] as const,

  viewers: (userId: string) => ['care', 'patients', 'viewers', userId] as const,
};
